
    <button class="left1"  mat-raised-button  (click)="AddPrvilege();">
        <span class="mdc-button__label colr" >Add Privileges</span>
    </button><br>

    
     <!-----------------Add privileges----------------->
    
     <div class="card wd" *ngIf="AddPrvShown">
        <form>
        <div class="card-body">
        <div class="form-group">
        <label for="exampleInputPassword1">Privilege Name</label><span class="error">{{PName}}</span>
        <input type="text" class="form-control" placeholder="Privilege name" name="name" [(ngModel)]="data.privilege_name"  (ngModelChange)="valuechange1($event)">
        </div>
        
        </div>
        <!-------------------Test alert---------------------->
        <div class="alert alert-success alert-dismissible alertWidth" *ngIf="isChange">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
            <h4><i class="icon fas fa-check"></i> {{alert}}</h4>
             
            </div>
        <!---------------------------------------
            
        <div class="sucess alertWidth" *ngIf="isChange">
            <span class="closebtn content " onclick="this.parentElement.style.display='none';">&times;</span> 
            {{alert}}
          </div>
        ---------------------------------------->
        <div class="card-footer">
        <button class="btns"  mat-raised-button (click)="AddNewPrivilege();">
            <span class="mdc-button__label colr" >Added</span>
        </button>
        </div>
        </form>
        </div>
<!---------------------------------new ui---------------------------------------------------->


    <section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Privileges</h1>
    </div>
    
    
    </div>
    </section>
    
    <section class="content">
    
    <div class="card">
    <div class="card-header">
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 35%">
    Privileges Name
    </th>
 
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.privilege_name}}
    </a>
    </td>
    
    <td class="project-actions text-right">
    <a class="btn btn-danger btn-sm" data-toggle="modal" data-target="#modal-sm" (click)="SetPrivilegeId(c._id,c.privilege_name);">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
    
    
   <!--------------------ui-------------------------------
    <div class="card add">

    <div class="card-header">
        <h3 class="card-title">User Privileges</h3>
     </div>
     <div class="card-body">
        <div id="example2_wrapper" class="dataTables_wrapper dt-bootstrap4">
            <div class="row"><div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6"></div></div><div class="row">
            <div class="col-sm-12"><table id="example2" class="table table-bordered table-hover dataTable dtr-inline collapsed" role="grid" aria-describedby="example2_info">
        <thead>
        <tr role="row">
            <th class="sorting sorting_desc" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Rendering engine: activate to sort column ascending" aria-sort="descending">Privileges Name</th>
            <th class="sorting" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Id</th>
            <th class="sorting" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending"></th>
        </thead>
        <tbody  *ngFor="let c of output">
        <tr class="odd">
        <td class="dtr-control sorting_1" tabindex="0">{{c.privilege_name}}</td>
        <td>{{c._id}}</td>
        <td>
            <button mat-raised-button data-toggle="modal" data-target="#modal-sm" (click)="SetPrivilegeId(c._id,c.privilege_name);">
                <span class="mdc-button__label delete">Delete</span>
            </button>


        </td>
        </tr>
       </tbody>
       </table>
       </div>  
       </div>
        </div>
    
        
        </div></div> 
   
--> 
 <!--------------------delete privilage notification---------------------------------------->
<div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
    <div class="modal-content">
    
    <div class="modal-body">
    <p>Delete {{deletePrvilegeName}}?</p>
    </div>
    <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="DeletePrivilege();">Yes</button>
    </div>
    </div>
    
    </div>
    
    </div>
